<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Cadastro de Modelo
        </h1>
      </b-col>
    </div>
    <b-card>
      <b-form>
        <b-alert variant="danger" :show="msgErroFormulario">
          {{ msgErroFormulario }}
        </b-alert>
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="6" xl="6">
            <b-form-group
              label="Descrição:"
              label-for="descricao"
              class="text-label"
            >
              <b-form-input
                v-model="filtro.descricao"
                type="text"
                id="descricao"
                style="text-transform: uppercase;"
                maxlength="150"
              />
            </b-form-group>
          </b-col>

          <b-col xs="6" sm="6" md="6" lg="6" xl="6">
            <b-form-group
              label="Movimento:"
              label-for="movimento"
              class="text-label"
            >
              <b-form-select v-model="filtro.movimento" :options="listaMovimento.options"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col xs="12" sm="12" md="12" lg="6" xl="6">
            <b-form-group
              label="Tipo Tramitação:"
              label-for="tipoTramitacao"
              class="text-label"
            >
              <b-form-select v-model="filtro.tipoTramitacao" :options="listaTipoTramitacao.options"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="8" xl="6">
            <b-form-group
              label="Tipo de Documento:"
              label-for="tipoDocumento"
              class="text-label"
            >
              <b-form-select v-model="filtro.tipoDocumento" :options="listaTipoDocumento.options"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col xs="12" sm="12" md="12" lg="8" xl="8">
            <b-form-group label="Situação:" label-for="situacao" class="text-label">
              <b-form-radio-group
                id="radio-group-1"
                v-model="filtro.situacao"
                :options="situacao.options"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>

      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between">
            <div>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                @click="filtrar"
              >
                <i class="fa fa-search"></i> Pesquisar
              </b-button>
              <b-button
                variant="primary"
                @click.prevent="openIncluir"
                class="fonte-branca ml-1"
              >
                <i class="fa fa-plus"></i> Incluir
              </b-button>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                :disabled="selecionados.length !== 1"
                @click.prevent="openAlterar"
              >
                <i class="fa fa-pencil"></i> Alterar
              </b-button>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                :disabled="selecionados.length !== 1"
                @click.prevent="openExibir"
              >
                <i class="fa fa-eye"></i> Exibir
              </b-button>
              <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                <i class="fa fa-eraser"></i> Limpar
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col xs="12" md="12" class="mx-auto">
          <b-col xs="12">
            <div>
              <b-row class="d-flex justify-content-between">
                <b-col>
                  <label class="mt-3">
                    Modelos - Quantidade:
                    <strong>{{ configTable.rows }}</strong>
                  </label>
                </b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
              <TabelaMinuta
                :resultado="items"
                :fields="fieldsModelo"
                :configTable="configTable"
                @selecionar="(sel) => selecionados = sel "
              />
              <b-row class="d-flex justify-content-between">
                <b-col style="background: #F0F3F5;" class="mx-3">
                  <div style="float: right;">
                    Total linhas: {{ getTotalInPage() }}
                  </div>
                </b-col>
              </b-row>
              <b-row class="d-flex justify-content-between mt-3">
                <b-col></b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </b-card>

  </b-container>
</template>

<script>
import axios from "axios";
import CompPaginacao from "../components/CompPaginacao";
import TabelaMinuta from "./TabelaMinuta";

const urlApi = process.env.VUE_APP_ROOT_API;
export default {
  name: "ManterMinuta",
  components: {
    CompPaginacao,
    TabelaMinuta,
  },
  data() {
    return {
      situacao: {
        selected: "todos",
        options: [
          { text: "Todos", value: "todos" },
          { text: "Ativo", value: "ativo" },
          { text: "Inativo", value: "inativo" },
        ],
      },
      items: [],
      fieldsModelo: [
        {
          key: "selecao",
          sortable: false,
          label: "Sel.",
          thStyle: {
            width: "40px"
          }
        },
        {
          key: "descricao",
          sortable: true,
          label: "Descrição",
        },
        {
          key: "descricaoMovimento",
          sortable: true,
          label: "Movimento",
        },
        {
          key: "textoTipoTramitacao",
          sortable: true,
          label: "Tipo de Tramitação",
        },
        {
          key: "tipoDocumento",
          sortable: true,
          label: "Tipo de Documento",
        },
        {
          key: "indAtivo",
          sortable: true,
          label: "Situação",
          thStyle: {
            width: "100px"
          }
        },
      ],
      selecionados: [],
      configTable: {
        perPage: 100,
        sortField: "descricao",
        currentPage: 1,
        rows: 0,
        checkedAll: false,
        load: false,
      },
      filtro: {
        descricao: null,
        movimento: null,
        tipoTramitacao: null,
        tipoDocumento: null,
        situacao: 'todos',
      },

      listaTipoTramitacao:{
        options:[
          {value: null, text: "Selecione" },
        ]
      },
      listaTipoDocumento:{
        options:[
          {value: null, text: "Selecione" },
          {value: 'APELACAO', text: "Apelação" },
          {value: 'CONTESTACAO', text: "Contestação" },
          {value: 'EMBARGOS', text: "Embargos de Declaração" },
          {value: 'PETICAO', text: "Petição Outras" },
        ]
      },
      listaMovimento:{
        options:[
          {value: null, text: "Selecione" },
        ]
      },
      msgErroFormulario: null,
    };
  },
  methods: {
    /**
     * Incluir
     */
    openIncluir(evt) {
      evt.preventDefault();
      this.$store.commit("setModeloMinuta", null);
      this.$router.push({ path: "/Minuta/editar" });
    },

    /**
     * Alterar
     */
    openAlterar(evt) {

      evt.preventDefault();
      if (this.selecionados[0]) {
        this.$store.commit("setModeloMinuta", this.selecionados[0]);
        this.$router.push({ path: "/Minuta/alterar" });
      }
    },

    /**
     * Exibir
     */
    openExibir(evt) {
      evt.preventDefault();
      if (this.selecionados[0]) {
        this.$store.commit("setModeloMinuta", this.selecionados[0]);
        this.$router.push({ path: "/Minuta/exibir" });
      }
    },

    /**
     * Consultar
     */
    async consultar() {
      this.loadingEnter();
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      const params = {
        ...this.filtro
      }
      axios.get(`${urlApi}/v1/modelopeticao`, {
          params: params,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        .then((response) => {
          const data = response.data
          this.items = data
          this.configTable.rows = data.length
        })
        .catch((error) => {
          error
        })
        .finally(() => {
          this.loadingExit();
        });
    },

    /**
     * Limpar os filtros de pesquisa
     */
    limparFiltro() {
      this.filtro = {
        descricao: null,
        movimento: null,
        tipoTramitacao: null,
        tipoMovimento: null,
        tipoDocumento: null,
        situacao: 'todos',
      };
      this.filtrar();
    },

    /**
     * Filtrar a consulta
     */
    filtrar() {
      this.configTable.currentPage = 1;
      this.configTable.rows = 0;
      this.configTable.checkedAll = false;
      this.resultado = [];
      this.selecionados = [];
      this.consultar();
    },

    /**
     * Listar movimento
     */
    async listarMovimentos() {
      const urlApi = process.env.VUE_APP_ROOT_API;
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      axios.get(`${urlApi}/v1/modelopeticao/movimento?movimentolocal=true&situacao=A`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then((response) => {
        response.data.forEach(el => {
          this.listaMovimento.options.push({value: el.codigo, text: el.descricao})
        });
      });
    },
    async listarTipoTramitacao() {
      const urlApi = process.env.VUE_APP_ROOT_API;
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      axios.get(`${urlApi}/v1/modelopeticao/tipotramitacao`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then((response) => {
        response.data.forEach(el => {
          this.listaTipoTramitacao.options.push({
            value: el.id,
            text: `${el.sigla} - ${el.nome}`
          })
        });
      });
    },

    /**
     * Exibe erros dos catch
     */
    exibirErro(error) {
      this.$store.commit("setMessages", { message: "Erro!", errors: [error] });
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingEnter() {
      this.configTable.load = true;
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingExit() {
      this.configTable.load = false;
    },

    getTotalInPage() {
      if (this.configTable.rows < this.configTable.perPage) {
        return this.configTable.rows
      } else {
        const qtdPg = this.configTable.rows / this.configTable.perPage

        if (this.configTable.currentPage < qtdPg) return this.configTable.perPage

        return this.configTable.rows - (this.configTable.perPage * (this.configTable.currentPage - 1))
      }
    }
  },
  watch: {
    perPage() {
      this.configTable.currentPage = 1;
      this.consultar();
    },
  },
  computed: {
    perPage() {
      return this.configTable.perPage;
    },
  },
  mounted() {
    const msgPeticao = this.$store.getters.getMsgPeticao;
    if(msgPeticao) {
        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [msgPeticao] });
        this.$store.commit("setMsgPeticao", null)
    }

    this.listarMovimentos()
    this.listarTipoTramitacao()
    this.consultar();
  },
};
</script>

<style scoped></style>
